
(function () {
  function byId(id) { return document.getElementById(id); }
  function money(cents, withCurrency) {
    var n = (cents || 0) / 100;
    return (withCurrency ? '£' : '') + n.toFixed(2); // swap to your formatter if needed
  }

  function filterVariants(variants, selection) {
    return variants.filter(function (v) {
      for (var i = 0; i < selection.length; i++) {
        if (!selection[i]) continue;
        if (v['option' + (i + 1)] !== selection[i]) return false;
      }
      return true;
    });
  }

  function uniqueValuesAt(variants, position, withinVariants) {
    var vals = new Set();
    (withinVariants || variants).forEach(function (v) {
      vals.add(v['option' + position]);
    });
    return Array.from(vals);
  }

  function renderSelect(select, values, position, selectionSoFar, variants) {
    select.innerHTML = '';
    values.forEach(function (val) {
      var nextSel = selectionSoFar.slice();
      nextSel[position - 1] = val;
      var matched = filterVariants(variants, nextSel);
      var anyAvailable = matched.some(function (m) { return m.available; });
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      if (!anyAvailable) opt.disabled = true;
      select.appendChild(opt);
    });
  }

  function setHeroNote(pid, available) {
    var el = byId('note-' + pid);
    if (!el) return;
    var txt = available ? (el.dataset.noteAvailable || el.textContent)
                        : (el.dataset.noteUnavailable || el.textContent);
    el.textContent = txt;
    el.classList.toggle('is-soldout', !available);
  }

  function buildSizedSrc(url, width) {
    if (!url) return '';
    return url.indexOf('?') === -1 ? (url + '?width=' + width) : (url + '&width=' + width);
  }
  function preload(url) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var img = new Image();
      img.onload = function () { resolve(url); };
      img.onerror = function () { resolve(null); };
      img.decoding = 'async';
      img.fetchPriority = 'high';
      img.src = url;
      if (img.decode) { img.decode().then(function(){ resolve(url); }).catch(function(){}); }
    });
  }
  // function setHeroImage(pid, product, variant) {
  //   var imgEl = byId('hero-img-' + pid);
  //   if (!imgEl) return;

  //   var vImgSrc = variant && variant.featured_image && variant.featured_image.src;
  //   var alt = (variant && variant.featured_image && variant.featured_image.alt) || product.title;

  //   if (!vImgSrc && variant && variant.featured_media && product.media && product.media.length) {
  //     var m = product.media.find(function (mm) { return mm.id === variant.featured_media.id; });
  //     if (m && m.preview_image && m.preview_image.src) {
  //       vImgSrc = m.preview_image.src;
  //       alt = m.alt || alt;
  //     }
  //   }

  //   var target600 = vImgSrc ? buildSizedSrc(vImgSrc, 600) : (imgEl.getAttribute('data-default-src') || '');
  //   var target900 = vImgSrc ? buildSizedSrc(vImgSrc, 900) : (imgEl.getAttribute('data-default-src') || '');
  //   var target1200 = vImgSrc ? buildSizedSrc(vImgSrc, 1200) : (imgEl.getAttribute('data-default-src') || '');

  //   var current = imgEl.currentSrc || imgEl.src;
  //   if (current && target900 && current.indexOf(target900) === 0) return;

  //   imgEl.classList.add('swapping','loading-next');
  //   preload(target900).then(function () {
  //     if (vImgSrc) {
  //       imgEl.alt = alt || '';
  //       imgEl.src = target900;
  //       imgEl.srcset = target600 + ' 600w, ' + target900 + ' 900w, ' + target1200 + ' 1200w';
  //     } else {
  //       imgEl.src = imgEl.getAttribute('data-default-src') || imgEl.src;
  //       imgEl.srcset = imgEl.getAttribute('data-default-srcset') || imgEl.srcset;
  //       imgEl.alt = imgEl.getAttribute('data-default-alt') || imgEl.alt;
  //     }
  //     var cleaned = false;
  //     function cleanup(){ if (cleaned) return; cleaned = true;
  //       imgEl.classList.remove('loading-next','swapping'); imgEl.removeEventListener('load', cleanup);
  //     }
  //     imgEl.addEventListener('load', cleanup);
  //     setTimeout(cleanup, 400);
  //   });
  // }

  function initVariantForms() {
    document.querySelectorAll('.variant-form').forEach(function (form) {
      if (form.hasAttribute('data-has-default')) return; // default-only product

      var pid = form.getAttribute('data-product-id');
      var jsonEl = byId('ProductJson-' + pid);
      if (!jsonEl) return;

      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var variants = product.variants || [];
      var selects = Array.from(form.querySelectorAll('.variant-input'))
        .sort(function (a, b) {
          return parseInt(a.dataset.optionPosition, 10) - parseInt(b.dataset.optionPosition, 10);
        });
      if (!selects.length) return;

      // Current selection (try to pick up preselected <option>s from Liquid)
      var current = selects.map(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        return opt ? opt.value : null;
      });

      // If first select is empty (no <option>s from Liquid), seed it
      if (!selects[0].options.length) {
        var opt1Values = uniqueValuesAt(variants, 1);
        renderSelect(selects[0], opt1Values, 1, current, variants);
        // Select first enabled
        var fe = Array.from(selects[0].options).find(function (o){ return !o.disabled; });
        if (fe) { selects[0].value = fe.value; current[0] = fe.value; }
      }

      function updateDownstream(fromIndex) {
        for (var i = fromIndex + 1; i < selects.length; i++) {
          var pos = i + 1;
          var pool = filterVariants(variants, current.slice(0, i));
          var values = uniqueValuesAt(variants, pos, pool);
          renderSelect(selects[i], values, pos, current, variants);
          var fei = Array.from(selects[i].options).find(function (o){ return !o.disabled; });
          if (fei) { selects[i].value = fei.value; current[i] = fei.value; } else { current[i] = null; }
        }
        bindVariant();
      }

      selects.forEach(function (sel, idx) {
        sel.addEventListener('change', function () {
          current[idx] = sel.value || null;
          updateDownstream(idx);
        });
      });

      var idInput = byId('variant-id-' + pid);
      var priceWrap = byId('price-' + pid);
      var atcBtn = byId('atc-' + pid);

      function bindVariant() {
        var exact = variants.find(function (v) {
          for (var i = 0; i < selects.length; i++) {
            var val = current[i];
            if (!val) return false;
            if (v['option' + (i + 1)] !== val) return false;
          }
          return true;
        });

        if (exact) {
          if (idInput) idInput.value = exact.id;
          if (priceWrap) {
            priceWrap.innerHTML =
              '<span class="advent-hero__price-now">' + money(exact.price, true) + '</span>' +
              (exact.compare_at_price > exact.price
                ? '<span class="advent-hero__price-was">' + money(exact.compare_at_price, true) + '</span>'
                : '');
          }
          if (atcBtn) { atcBtn.disabled = !exact.available; atcBtn.textContent = exact.available ? 'Add to cart' : 'Unavailable'; }
          setHeroNote(pid, !!exact.available);
          setHeroImage(pid, product, exact);
        } else {
          if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
          setHeroNote(pid, false);
        }
      }

      // Kick things off
      updateDownstream(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantForms);
  } else {
    initVariantForms();
  }
})();

